<div *ngIf="inProgress">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  loading....
</div>

<div class="center-content2 armabox">
  <!-- Header -->
  <div class="table-header armarow header">
    <div class="medium-border-arma-color table-title-fit-content">
      {{ 'Mes factures' | translate }}
    </div>

    <span class="filler"></span>

    <div *ngIf="!inProgress && HTML_TABLE_DATASOURCE.data?.length == 0" class="medium-border-arma-color table-title-fit-content">
      {{'Aucune facture trouvé !' | translate}}
    </div>
    <div>
      <mat-form-field style="margin: auto; min-width: 350px; max-height: 50px;">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput (keyup)="onFilterChange($event.target.value)" placeholder="{{'Rechercher' | translate}}">
      </mat-form-field>
    </div>

    <span class="filler"></span>

    <button mat-raised-button
      class="fit-h-centered-btn"
      [disabled]="HTML_TABLE_DATASOURCE.data.length == 0"
      (click)="downloadAll()">{{ 'Télécharger tout' | translate }}
    </button>

  </div>
  <!-- Content -->
  <div class="armarow content">
    <table style="width: 100%;" mat-table #tableCommande [dataSource]="HTML_TABLE_DATASOURCE" matSort
      class="mat-elevation-z8 medium-border-arma-color">

      <!-- DOC_NO -->
      <ng-container matColumnDef="DOC_NO">
        <th style="width: 110px" mat-header-cell *matHeaderCellDef mat-sort-header> {{'Facture n°'| translate}} </th>
        <td mat-cell *matCellDef="let element"><div>{{element.DOC_NO}}</div></td>
      </ng-container>

      <!-- DOC_DATE -->
      <ng-container matColumnDef="DOC_DATE">
        <th style="width: 110px" mat-header-cell *matHeaderCellDef> {{'Date'| translate}} </th>
        <td mat-cell *matCellDef="let element"><div>{{element.DOC_DATE}}</div></td>
      </ng-container>

      <!-- DOC_VALUE -->
      <ng-container matColumnDef="DOC_VALUE">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="invoice-price"> {{'Prix'| translate}} </div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="invoice-price">{{element.DOC_VALUE}}</div>
        </td>
      </ng-container>

      <!-- ACTION -->
      <ng-container matColumnDef="Action">
        <th style="width: 250px" mat-header-cell *matHeaderCellDef>{{'Action'| translate}}</th>
        <td mat-cell *matCellDef="let element">
          <button
              style="margin: 0 1px;"
              mat-stroked-button
              (click)="getInvoice(element, false)"
              matTooltip="{{'Consulter' | translate}}">
              <img height="24px" src="assets/icons/view.png">
          </button>
          <button
              style="margin: 0 1px;"
              mat-stroked-button
              (click)="getInvoice(element, true)"
              matTooltip="{{'Télécharger' | translate}}">
              <img height="24px" src="assets/icons/download.png">
          </button>
        </td>
      </ng-container>

      <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="HTML_TABLE_HEADER_COL; sticky: true">
      </tr>
      <tr mat-row *matRowDef="let row; columns: HTML_TABLE_HEADER_COL;" class="hover-table-smoke"></tr>
    </table>
  </div>
</div>
